import moment, { Moment } from "moment";
import React from "react";
import Button from "src/app/components/button/button";
import { ActiveFilter } from "src/app/crawler/crawler.interface";
import { __findLaterDate, __formatDateYYYY_MM_DD } from "src/app/utils/dateTimeUtils";


export interface CreatedAtDateFilterProps {
    activeFilters: ActiveFilter[];
    submitFilterValue: (filter: ActiveFilter) => void;
}

function CreatedAtDateFilter({ activeFilters, submitFilterValue }: CreatedAtDateFilterProps) {

    const [startDate, setStartDate] = React.useState<string>(() => checkForDefaultFilter('fromDate'));
    const [endDate, setEndDate] = React.useState<string>(() => checkForDefaultFilter('toDate'));
    const [errorMsg, setErrorMsg] = React.useState('');

    function checkForDefaultFilter(dateField: string): string {
        const createdAtFilterIndex = activeFilters.findIndex((filter: ActiveFilter) => filter.name === 'created_at');
        if (createdAtFilterIndex !== -1) {
            const dates = activeFilters[createdAtFilterIndex].value.split('..');

            if (dateField === 'fromDate') {
                const startDate = __formatDateYYYY_MM_DD(dates[0]);
                return startDate;
            } else if (dateField === 'toDate') {
                const endDate = __formatDateYYYY_MM_DD(dates[1]);
                return endDate;
            }
        }
        return '';
    }

    // selectedDate: YYYY-MM-DD
    function handleDateChange(dateField: string, selectedDate?: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
        if (selectedDate != null) {
            if (dateField === 'fromDate') {
                setStartDate(selectedDate);
            } else if (dateField === 'toDate') {
                setEndDate(selectedDate);
            }
        }
    }

    function handleCreatedDateSubmit() {
        if (isDateRangeValid(moment(startDate), moment(endDate), 'From Date must be before End Date')) {
            const formattedStartDate = moment(startDate).format('MM-DD-YYYY');
            const formattedEndDate = moment(endDate).format('MM-DD-YYYY');
            submitFilterValue({ name: 'created_at', value: `${formattedStartDate}..${formattedEndDate}` });
        }
    }

    function isDateRangeValid(dateA: Moment, dateB: Moment, errorMessage: string,) {
        if (!(startDate && endDate)) {
            setErrorMsg('From Date and To Date are Required');
            return false;
        } else {
            if (__findLaterDate(dateA, dateB)) {
                setErrorMsg(errorMessage);
                return false;
            } else {
                setErrorMsg('');
                return true;
            }
        }
    }

    return (
        <>
            <div className="date-picker-wrapper">
                <div className="date-picker-from">
                    <label htmlFor="date-from">From:</label>
                    <input className="date-input" type="date" id="date-from"
                        value={startDate}
                        onChange={(e) => handleDateChange('fromDate', e.target.value)}
                        min="1776-01-01"
                        max="3000-01-01"
                        placeholder="yyyy-mm-dd"
                    />

                </div>
                <div className="date-picker-to">
                    <label htmlFor="date-to">To:</label>
                    <input className="date-input" type="date" id="date-to"
                        value={endDate}
                        onChange={(e) => handleDateChange('toDate', e.target.value)}
                        min="1776-01-01"
                        max="3000-01-01" />
                </div>
            </div>
            {errorMsg.length > 0 ?
                <div className="date-range-error error">
                    *{errorMsg}
                </div>
                :
                null
            }

            <div className="center-button">
                <Button variant="button button--small" onClick={handleCreatedDateSubmit}>Submit</Button>
            </div>
        </>
    );
}
export default CreatedAtDateFilter;